
export const pricingSelector = state => state.pricing;
